/**
 * Component Registry for Rebel Residential Theme
 * 
 * Extends the base belmont theme registry with Rebel Residential specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-belmont/registry';

/**
 * Rebel Residential specific component overrides.
 * These components have been customized for the Rebel Residential brand.
 * 
 * Example:
 * import { Footer } from './components/Footer';
 * 
 * const rebelresidentialOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const rebelresidentialOverrides: Partial<ComponentRegistry> = {
  // Add component overrides here
};

/**
 * Final merged registry for Rebel Residential properties.
 * Inherits all components from the belmont theme, with Rebel Residential overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...rebelresidentialOverrides,
};

export default registry;
